"use client";

import { Button, Icon } from "@pamperedchef/design-system";

import * as styles from "./BackToPreviousView.module.scss";

export interface BackToPreviousViewProps {
	label?: string;
	onClick?: () => void;
}

/**
 * BackToPrevious composite component
 */
export function BackToPreviousView({
	label,
	onClick
}: BackToPreviousViewProps): JSX.Element {
	return (
		<div className={styles["back-previous"]}>
			<Button
				kind="tertiary"
				size="sm"
				className={styles["back-previous__button"]}
				onClick={() => onClick?.()}
			>
				<span>
					<Icon name="ArrowLeft" size={12} />
				</span>
				<span>{label}</span>
			</Button>
		</div>
	);
}
